import { twMerge } from 'tailwind-merge';
import cx from 'classnames';
import React from 'react';

import { cn } from '../utils';

export default function Input(props: {
  className?: string;
  adornmentStart?: React.ReactNode;
  adornmentStartWrapperProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  adornmentEndWrapperProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  adornmentEnd?: React.ReactNode;
  error?: boolean | string;
  label?: string;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  wrapperProps?: Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'className'
  >;
  containerProps?: React.ComponentProps<'div'>;
}): React.ReactElement {
  return (
    <div {...props.containerProps} className={cn('flex flex-col', props.containerProps?.className)}>
      {props.label && (
        <label
          {...props.labelProps}
          className={twMerge(
            'text-neutral-0 mb-2 font-body font-medium leading-4',
            props.labelProps?.className,
          )}
        >
          {props.label}
        </label>
      )}
      <div
        {...props.wrapperProps}
        className={twMerge(
          'inline-flex items-center border-neutral-70 border rounded-lg hover:border-neutral-50 focus-within:!border-primary-30',
          cx({
            'bg-neutral-97 pointer-events-none select-none': props.inputProps?.disabled,
            '!border-error-30': !!props.error,
          }),
          props.className,
        )}
      >
        {props.adornmentStart && (
          <div
            className={twMerge(
              'pointer-events-none w-5 h-5 ml-[14px] min-w-[20px]',
              props.adornmentStartWrapperProps?.className,
            )}
          >
            {props.adornmentStart}
          </div>
        )}
        <input
          {...props.inputProps}
          className={cx(
            'flex-1 w-full px-4 py-[14px] placeholder-neutral-50 focus:outline-none text-neutral-0',
            'disabled:placeholder-opacity-100 disabled:bg-transparent/0 disabled:text-neutral-50 disabled:border-transparent rounded-[inherit]',
            props.inputProps?.className,
          )}
        />
        {props.adornmentEnd && (
          <div
            className={twMerge(
              'pointer-events-none w-5 h-5 mr-[14px] min-w-[20px]',
              props.adornmentEndWrapperProps?.className,
            )}
          >
            {props.adornmentEnd}
          </div>
        )}
      </div>
      {typeof props.error === 'string' && (
        <p className="font-body text-[0.75rem] leading-[1rem] text-error-30 mt-3">{props.error}</p>
      )}
    </div>
  );
}
